import api from '@/lib/axios';
import type { PaginatedResult } from '@/components/data-table';

export const MATERIAL_UNITS = ['nos', 'kg', 'g', 'm', 'box', 'pkt', 'ltr', 'dozen'] as const;
export type MaterialUnit = (typeof MATERIAL_UNITS)[number];

export interface MaterialItem {
  id: string;
  name: string;
  description: string | null;
  unit: MaterialUnit;
  status: 'active' | 'inactive';
  createdAt: string;
  updatedAt: string;
}

export interface MaterialItemListParams {
  page?: number;
  limit?: number;
  search?: string;
  status?: 'active' | 'inactive';
}

export interface MaterialItemPayload {
  name: string;
  description?: string;
  unit: MaterialUnit;
  status?: 'active' | 'inactive';
}

function unwrap<T>(r: { data: { data?: T } | T }): T {
  const body: any = r.data;
  return (body?.data ?? body) as T;
}

export const MaterialItemsApi = {
  list: async (params?: MaterialItemListParams): Promise<PaginatedResult<MaterialItem>> =>
    unwrap(await api.get('/material-items', { params })),
  listActive: async (): Promise<MaterialItem[]> =>
    (await unwrap<PaginatedResult<MaterialItem>>(await api.get('/material-items', { params: { status: 'active', limit: 100 } }))).items,
  get: async (id: string): Promise<MaterialItem> => unwrap(await api.get(`/material-items/${id}`)),
  create: async (data: MaterialItemPayload): Promise<MaterialItem> =>
    unwrap(await api.post('/material-items', data)),
  update: async (id: string, data: Partial<MaterialItemPayload>): Promise<MaterialItem> =>
    unwrap(await api.patch(`/material-items/${id}`, data)),
  remove: async (id: string): Promise<{ id: string }> => unwrap(await api.delete(`/material-items/${id}`)),
};
